export const ALL = 'ALL';

export function parseByMenu(items, idMenu) {
	return items.hasOwnProperty(idMenu) ? items[idMenu] : {};
}
